import { render, staticRenderFns } from "./ActionsComponent.vue?vue&type=template&id=3defd952&scoped=true"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionsComponent.vue?vue&type=style&index=0&id=3defd952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defd952",
  null
  
)

export default component.exports